<template>
  <!-- 专题管理 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加专题</el-button
    >
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="ProjectManagement"
    @update-list="updateList"
    excelName="专题管理"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
    @handleSelection="handleSelection"
  >
     <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
    <template #adminIdCustom="scope">
      <span>{{ adminName }}</span>
    </template>
    <template #channelCountCustom="scope">
      <span
        v-if="scope.scope.channelCount > 0"
        class="hand blue"
        @click="openChannelCount(scope.scope)"
        >已关联{{ scope.scope.channelCount }}个专题/院校</span
      >
      <span class="gray" v-else>未设置</span>
    </template>
  </TableList>

  <!-- 添加编辑 专题管理 -->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="640px"
     draggable
              destroy-on-close
  >
    <AddEditProject
      v-if="addEditVisible"
      :edit-id="editId"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditProject>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import { reactive, onMounted, toRefs, computed, toRaw,h, nextTick,ref } from "vue";
import AddEditProject from "views/projectManagement/AddEditProject.vue";
import {
  getAllSpecialTopic,
  removeSpecialTopic,
} from "network/projectManagement.js";
import store from "../../store/index";

export default {
  name: "ProjectManagement",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    AddEditProject,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      tableData: [],
      multipleSelection:[],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },{
          label: "专题名称",
          prop: "name",
          minwidth: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        // {
        //   label: "所属分类",
        //   prop: "categoryName",
        //   width: "160",
        //   align: "center",
        //   noSetText: "未设置",
        // },
        {
          label: "文章数目",
          prop: "articlesCount",
          width: "160",
          align: "center",
          noSetText: "未设置",
          unit: "篇", //单位
        },
        // {
        //   label: "关键字",
        //   prop: "keyword",
        //   width: "250",
        //   align: "center",
        //   noSetText: "未设置",
        //   isTagArr: true,
        // },

        // {
        //   label: "描述",
        //   prop: "remarks",
        //   minwidth: "300",
        //   align: "center",
        //   noSetText: "未设置",
        // },
        {
          label: "创建时间",
          prop: "createTime",
          width: "200",
          align: "center",
          noSetText: "未设置",
        },
      ],
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      name: "", //筛选 专题名称
      dialogTitle: "添加专题",
      addEditVisible: false, //添加编辑弹窗
      editId: 0, //是否是编辑
    });
    //挂载后调用函数获取项目数据
    onMounted(() => {
      getProjectData(); //请求专题列表数据
    });

    // 获取列表
    const getProjectData = () => {
      data.loading = true;
      getAllSpecialTopic(data.name)
        .then((result) => {
          
          if (result && result.code == 1) {
            const dataList = result.result;
            data.tableData = dataList;
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.name = val.value;
      }
      getProjectData();
    };

    //更新列表
    const updateList = () => {
      getProjectData();
    };

    // 添加
    const addFnc = () => {
      data.addEditVisible = true;
      data.dialogTitle = "添加专题";
      data.editId = 0;
    };

    // 编辑专题
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${data.multipleSelection[0].name}】专题`;
      data.editId = data.multipleSelection[0].id;
    };

    // 删除
    const deleteFnc = (obj) => {
         ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${data.multipleSelection[0].name}`
          ),
          h("span", null, "】专题？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            removeSpecialTopic(data.multipleSelection[0].id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteData(obj.id);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      removeSpecialTopic(id)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };
// 表格多选行处理
const handleSelection = (row) => {
  data.multipleSelection = JSON.parse(JSON.stringify(row));
};
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getProjectData,
      searchFnc,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      handleSelection,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
    };
  },
};
</script>
<style scoped>
</style>

